import 'isomorphic-fetch';
import { Environment, Store, RecordSource, Network } from 'relay-runtime';
import serverVars from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { createFetcher } from 'dibs-relay-network-layer/client';

export function clientRelayEnvironment(records) {
    const network = Network.create(
        createFetcher({
            getQueries: () => ({
                ...getBuyerToken(document.cookie),
                locale: serverVars.get('locale'),
            }),
        })
    );
    const source = new RecordSource(records);
    const store = new Store(source);

    return new Environment({ network, store });
}
